import cn from 'classnames';
import styles from './AnswerBlock.module.scss';

export const AnswerBlock = ({ children, className,...props }) => {
  return (
    <div className={cn(styles.block, className)} {...props}>
      {children}
    </div>
  )
}